import { Link, useLocation } from "react-router-dom";

import { Breadcrumb, BreadcrumbLink, Headline } from "@fronterahealth/frontera-ui-components";

import { BCBAMetrics } from "@pages/VideoAnalytics/BCBAs/BCBAMetrics";
import { Overview } from "@pages/VideoAnalytics/Overview/Overview";
import { RBTMetrics } from "@pages/VideoAnalytics/RBTs/RBTMetrics";
import { AnalyticsTab } from "@pages/VideoAnalytics/components/AnalyticsTab";
import { useVideoAnalytics } from "@providers/VideoAnalyticsProvider";

export const VideoAnalytics = () => {
  const { pathname } = useLocation();
  // Hardcoded rather than derived via pathNameToBreadCrumbLinks — the URL segment
  // ("analytics") would otherwise render as "Analytics", colliding in label with
  // the unrelated admin Analytics page. See PROA-1953.
  const breadcrumbLinks: BreadcrumbLink[] = [
    {
      name: "Video Analytics",
      current: true,
      type: "component",
      Component: <Link to={pathname}>Video Analytics</Link>,
    },
  ];
  const { selectedAnalyticTab } = useVideoAnalytics();

  return (
    <div className="w-full  mx-auto flex flex-col gap-4 px-4">
      <Breadcrumb
        links={breadcrumbLinks}
        homeLink={{
          name: "Home",
          Component: <Link to={`/analytics`}>Home</Link>,
          current: false,
          type: "component",
        }}
      />
      <Headline size="medium" className="text-xl md:text-4xl">
        Video Analytics
      </Headline>
      <div className="w-full flex flex-col gap-4 pb-4">
        <AnalyticsTab />
        {selectedAnalyticTab === "My Metrics" || selectedAnalyticTab === "BCBAs" ? (
          <BCBAMetrics />
        ) : selectedAnalyticTab === "RBTs" ? (
          <RBTMetrics />
        ) : (
          <Overview />
        )}
      </div>
    </div>
  );
};
